import React from "react";
import {
  Filter,
  TextInput,
  LongTextInput,
  Toolbar,
  Button,
  Link,
  ImageInput,
  ImageField,
  SaveButton,
  Create,
  List,
  Datagrid,
  TextField,
  Pagination,
  Edit,
  SimpleForm,
  EditButton
} from "react-admin";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import withStyles from "@material-ui/core/styles/withStyles";
import { isNil } from "ramda";

const styles = {
  root: {
    display: "inline-block",
    marginTop: "1em",
    zIndex: 2,
    width: "100%",
    textAlign: "center"
  },
  content: { padding: 0, "&:last-child": { padding: 0 } },
  img: {
    width: "initial",
    minWidth: "initial",
    maxWidth: "42em",
    maxHeight: "15em"
  }
};

const TourNamePagination = props => (
  <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />
);

const TourNameFielter = props => (
  <Filter {...props}>
    <TextInput label="Search" source="tour_name_en" alwaysOn />
  </Filter>
);

const Poster = withStyles(styles)(({ classes, record }) => {
  if (!isNil(record.image_url)) {
    return (
      <Card className={classes.root}>
        <CardContent className={classes.content}>
          <img src={`${record.image_url}`} alt="" className={classes.img} />
        </CardContent>
      </Card>
    );
  } else {
    return <Card className={classes.root}>No image</Card>;
  }
});

export const TourNameList = props => (
  <List
    {...props}
    resource="tour_names"
    pagination={<TourNamePagination />}
    filters={<TourNameFielter />}
    bulkActionButtons={false}
  >
    <Datagrid>
      <TextField label="TourName ID" source="id" />
      <TextField label="Tour Name" source="tour_name_en" />
      <TextField label="Tour Description" source="tour_desc" />
      {/* <ReferenceField label="Tour Zone" source="tour_zone_id" reference="tour_zones" allowEmpty={true}>
          <TextField source="description_en" />
      </ReferenceField> */}
      <EditButton />
      {/* <DeleteButton /> */}
    </Datagrid>
  </List>
);

const TourMamesToolbar = props => (
  <Toolbar {...props}>
    <SaveButton redirect={`/tour_names`} />
    <Button
      component={Link}
      to={{
        pathname: `/tour_names`
      }}
      label="Back to to tour names"
    >
      <ArrowBackIcon />
    </Button>
  </Toolbar>
);

const TourNameTitle = object => (
  <span>
    {" Edit Tour Name"} &quot;{object.record.tour_name_en}&quot;
  </span>
);

const TourNameCreateTitle = record => <span>Create Tour Name</span>;

export const TourNameEdit = props => (
  <Edit title={<TourNameTitle />} {...props}>
    <SimpleForm toolbar={<TourMamesToolbar props={{ ...props }} />}>
      <LongTextInput label="Tour Name (EN)" source="tour_name_en" />
      <LongTextInput label="Tour Name (ES)" source="tour_name_es" />
      <LongTextInput label="Tour Name (DE)" source="tour_name_de" />
      <LongTextInput label="Tour Name (PT)" source="tour_name_pt" />
      <LongTextInput label="Tour Description" source="tour_desc" />
      {/* <ReferenceInput
        label="Tour Zone"
        source="tour_zone_id"
        reference="tour_zones"
        sort={{ field: "id", order: "ASC" }}
      >
        <SelectInput source="id" optionText="description_en" />
      </ReferenceInput> */}
      <Poster />
      <ImageInput
        source="files"
        label="Model Image"
        accept="image/*"
        multiple={true}
      >
        <ImageField source="model_image" title="title" />
      </ImageInput>
    </SimpleForm>
  </Edit>
);

export const TourNameCreate = props => (
  <Create title={<TourNameCreateTitle />} {...props}>
    <SimpleForm toolbar={<TourMamesToolbar props={{ ...props }} />}>
      <LongTextInput label="Tour Name (EN)" source="tour_name_en" />
      <LongTextInput label="Tour Name (ES)" source="tour_name_es" />
      <LongTextInput label="Tour Name (DE)" source="tour_name_de" />
      <LongTextInput label="Tour Name (PT)" source="tour_name_pt" />
      <LongTextInput label="Tour Description" source="tour_desc" />
      {/* <ReferenceInput
        label="Tour Zone"
        source="tour_zone_id"
        reference="tour_zones"
        sort={{ field: "id", order: "ASC" }}
      >
        <SelectInput source="id" optionText="description_en" />
      </ReferenceInput> */}
    </SimpleForm>
  </Create>
);



// WEBPACK FOOTER //
// ./src/resources/tourNames.js